import {useTranslation} from '@/translations/i18n'
import {DialogStore} from '@ariakit/react'
import {Dialog, DialogDismiss, DialogFooter, DialogProvider} from '@components/ui/dialog-atoms/DialogAtoms.tsx'
import {Button} from '@components/ui/button/Button.tsx'
import {Spinner} from '@components/ui/spinner/Spinner'
import {StyledDialogHeader, StyledDialogBody} from './style'

interface ProPhotosDeleteImageModalProps {
    store: DialogStore
    onDelete: (e: React.MouseEvent<HTMLButtonElement>) => void
    onClose: () => void
    isPending: boolean
}

export const ProPhotosDeleteImageModal = ({store, onDelete, isPending, onClose}: ProPhotosDeleteImageModalProps) => {
    const {t} = useTranslation()

    return (
        <DialogProvider store={store}>
            <Dialog width={'480px'} hideOnInteractOutside={!isPending}>
                <StyledDialogHeader>
                    <DialogDismiss disabled={isPending} />
                </StyledDialogHeader>
                <StyledDialogBody gap={2}>
                    <h3>{t('vetting:reordering:delete_photo_modal:title')}</h3>
                    <p>{t('vetting:reordering:delete_photo_modal:description')}</p>
                </StyledDialogBody>
                <DialogFooter>
                    <Button variant={'tertiary'} onClick={onClose} disabled={isPending}>
                        {t('commons:cancel')}
                    </Button>

                    <Button variant={'primaryDanger'} onClick={onDelete} disabled={isPending}>
                        {t('vetting:reordering:delete_photo_modal:cta')}
                        {isPending && <Spinner size={20} />}
                    </Button>
                </DialogFooter>
            </Dialog>
        </DialogProvider>
    )
}
